import { z } from 'zod';
import { servicesProviderPricingFlatFeeSchema, servicesProviderPricingVehicleTypeCCSchema, servicesProviderPricingFlatFeeDtoSchema, servicesProviderPricingVehicleTypeCCDtoSchema } from '../ServicesProviderPricing.js';
import { serviceConfigSchema } from './SharedServiceConfig.js';

// ============================================================================
// Pricing Schemas
// ============================================================================
const inspectionServicePricingSchema = z.discriminatedUnion('model', [
    servicesProviderPricingFlatFeeSchema,
    servicesProviderPricingVehicleTypeCCSchema,
]);
const inspectionServicePricingDtoSchema = z.discriminatedUnion('model', [
    servicesProviderPricingFlatFeeDtoSchema,
    servicesProviderPricingVehicleTypeCCDtoSchema,
]);
// ============================================================================
// Core Schema
// ============================================================================
const inspectionServiceConfigSchema = serviceConfigSchema.extend({
    pricing: z.array(inspectionServicePricingSchema),
});
// ============================================================================
// DTO Schema
// ============================================================================
const inspectionServiceConfigDtoSchema = serviceConfigSchema.extend({
    pricing: z.array(inspectionServicePricingDtoSchema),
});

export { inspectionServiceConfigDtoSchema, inspectionServiceConfigSchema, inspectionServicePricingDtoSchema, inspectionServicePricingSchema };
//# sourceMappingURL=InspectionServiceConfig.js.map
